<template>
  <div class="w-full min-h-[100vh] p-6 flex flex-col items-center justify-end pb-20 bg-[#F7F8F9]">
    <img src="/images/logo_square.svg" class="w-24 mb-10">

    <div class="max-w-[400px] shadow-lg w-full px-8 bg-white rounded-xl z-50 relative">
      <slot></slot>
    </div>

    <div class="text-center pt-10">
      <span class="text-neutral-500">Vous êtes sur le backoffice des marchands pour retourner sur Delicity.com, <a href="https://delicity.com" class="font-bold text-neutral-800">cliquez ici</a></span>
    </div>

  </div>
</template>

